import Flickity from 'flickity';
import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { MotionPathHelper } from "gsap/MotionPathHelper";
gsap.registerPlugin(CustomEase, ScrollTrigger, MotionPathPlugin, MotionPathHelper);

window.addEventListener('load', function () {

	if( document.body.classList.contains('home')) {

		gsap.to("#rabbit-animation__rabbit", {
      opacity:1,
      duration:1,
      scrollTrigger: {
        trigger: ".home-featured",
        start:"top 100%",
      },
      motionPath:{
        path: "#rabbit-animation__path",
        align: "#rabbit-animation__path",
        autoRotate: false,
        alignOrigin: [0.5, 0.5],
        start:1,
        end: 0
      }
    });

	}

}, false);